import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SharedModule } from '../../shared/shared.module';
import { CrudNgxTableComponent as NgxTableComponent } from './crud-ngx-table/crud-ngx-table.component';

import { NgxTablePopupComponent } from './crud-ngx-table/ngx-table-popup/ngx-table-popup.component'
import { SharedMaterialModule } from 'app/shared/shared-material.module';
import { MatrixNgxTableComponent } from './matrix-ngx-table/matrix-ngx-table.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    SharedModule,
    SharedMaterialModule
  ],
  declarations: [NgxTableComponent, NgxTablePopupComponent, MatrixNgxTableComponent],
  exports:[NgxTableComponent, MatrixNgxTableComponent]
})
export class TablesModule { }
